import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';
import { VODCSSModules } from 'shared/utils/wix-connect';

import { getVideosGroupedByIds } from 'shared/selectors/videos';
import bi from 'shared/bi/bi';

import ContentSlider from 'widget/components/content-slider/content-slider';
import PageList from 'widget/components/page-list/page-list';
import Nav from 'widget/components/nav/nav';
import VideoListItem from 'widget/views/desktop/compact/components/videos/video-list-item/video-list-item';

import styles from './videos.styl';


@connect(state => ({
  videoByIds: getVideosGroupedByIds(state),
}))
@VODCSSModules(styles)
export default class Videos extends React.Component {

  static propTypes = {
    OverlayActionsCallbacks: React.PropTypes.func,

    channelData: React.PropTypes.object,

    containerWidth: React.PropTypes.number,

    videoByIds: React.PropTypes.object,
    videoIdsByPageNumber: React.PropTypes.array,

    thumbnailSize: React.PropTypes.shape({
      width: React.PropTypes.number,
      height: React.PropTypes.number,
    }),

    onSlideToPrev: React.PropTypes.func,
    onSlideToNext: React.PropTypes.func,
    onBeforeClick: React.PropTypes.func,
    onBeforePlayRequested: React.PropTypes.func,

    currentVideosPageNumber: React.PropTypes.number,
  };

  componentWillReceiveProps({ currentVideosPageNumber }) {
    if (currentVideosPageNumber !== this.props.currentVideosPageNumber) {
      bi.logWidgetSystem('videoList.changePage.rendered', { previousEventName: 'videoList.changePage.requested' });
    }
  }

  componentDidUpdate() {
    bi.logWidgetSystem('videoList.show.rendered', { previousEventName: 'videoList.show.requested' });
  }

  @autobind
  renderVideoItem(videoId) {
    const {
      channelData,
      videoByIds,
      thumbnailSize,
      OverlayActionsCallbacks,
      onBeforeClick,
      onBeforePlayRequested,
    } = this.props;

    const videoItem = videoByIds[videoId];

    return (
      <VideoListItem {...thumbnailSize}
                     OverlayActionsCallbacks={OverlayActionsCallbacks}
                     onBeforeClick={onBeforeClick}
                     onBeforePlayRequested={onBeforePlayRequested}
                     channelData={channelData}
                     videoItem={videoItem}
                     key={videoId} />

    );
  }

  hasPage(pageNum) {
    const { videoIdsByPageNumber } = this.props;
    return Boolean(videoIdsByPageNumber[pageNum]);
  }

  get isPrevPageVisible() {
    const { currentVideosPageNumber } = this.props;
    return this.hasPage(currentVideosPageNumber - 1);
  }

  get isNextPageVisible() {
    const { currentVideosPageNumber } = this.props;
    return this.hasPage(currentVideosPageNumber + 1);
  }

  render() {
    const {
      currentVideosPageNumber,
      videoIdsByPageNumber,
      containerWidth,
      onSlideToPrev,
      onSlideToNext,
    } = this.props;

    return (
      <section styleName="container">
        <ContentSlider width={containerWidth}
                       currentPageNumber={currentVideosPageNumber}>
          <PageList pageWidth={containerWidth}
                    currentPageNumber={currentVideosPageNumber}
                    itemsByPageNumber={videoIdsByPageNumber}
                    renderItem={this.renderVideoItem} />
        </ContentSlider>
        <Nav prevButtonClassName={styles['prev-button']}
             nextButtonClassName={styles['next-button']}
             onPrevClick={onSlideToPrev}
             onNextClick={onSlideToNext}
             isPrevVisible={this.isPrevPageVisible}
             isNextVisible={this.isNextPageVisible} />
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/videos/videos.js